export default {
  'reportsSettings.sales.title': '报表设置',
  'reportsSettings.general': '通用',
  'reportsSettings.service_period': '就餐时段',
  'reportsSettings.general.deferred_sales_enable': '应收金额不包含 “预付金额”（预付总结会单独的展示）',
  'reportsSettings.service_period.add.title': '添加你的“就餐时段”',
  'reportsSettings.service_period.add.column.name': '名称',
  'reportsSettings.service_period.name.placeholder': `例如‘午餐’`,
  'reportsSettings.service_period.add.column.foreign_name': '名称(中文)',
  'reportsSettings.service_period.add.column.description': '描述',
  'reportsSettings.service_period.define.title': '定义你的“就餐时段”',
  'reportsSettings.service_period.define.column.schedule_name': '计划名称',
  'reportsSettings.service_period.define.column.weekly_schedule': '周计划',
  'reportsSettings.service_period.define.column.service': '服务',
  'reportsSettings.service_period.define.column.available': '可用',
  'reportsSettings.service_period.define.column.hours': '时间',
  'reportsSettings.service_period.define.column.hours.tips': '时间段包含开始时间不包含结束时间',
  'reportsSettings.service_period.noScheduleName': '（无计划名称）',
  'reportsSettings.service_period.noHoursSet': '未设置时间',
  'reportsSettings.service_period.schedul_name.placeholder': `例如’周一至周四‘、’周日‘或’节假日‘`,
  'reportsSettings.service_period.confirm.delete': `确认删除？`,
  'reportsSettings.service_period.confirm.rules.one': `时间段与关单时间重合`,
  'reportsSettings.service_period.confirm.rules.two': `{plan1} 和 {plan2} 时间段有重叠`,
  'reportsSettings.service_period.duplication': `存在重复`,
  'reportsSettings.service_period.add.deleteTip': `下方有计划正在使用，它不能删除！`,
  'reportsSettings.service_period.overnightHours': `夜间时间`,
  'reportsSettings.service_period.valid.tips': `您修改了cut off时间，请重新检查并保存您的服务时段设置。`,
  'reportsSettings.service_period.closeoutReportCutoffTime': '报告截止时间: （{cutoffTime}）',

  'reportsSettings.sales_section.add.title': `添加你的“销售区域”`,
  'reportsSettings.sales_section.name.placeholder': `例如 ‘派对室,吧台’`,
  'reportsSettings.sales_section.define.title': `定义你的“销售区域”`,
  'reportsSettings.sales_section.define.column.section_name': '区域',
  'reportsSettings.sales_section.define.column.table': '桌子',
  'reportsSettings.sales_section.define.column.sales_section': '销售区域',
};
